const COMPONENT_PREFIX = "one-widget";

export const ONE_WIDGET_TEST_IDS = {
    CONTAINER: `${COMPONENT_PREFIX}-container`,
    HEADER: `${COMPONENT_PREFIX}-header`,
    BENEFITS: `${COMPONENT_PREFIX}-benefits`,
    PURCHASE_PLAN: `${COMPONENT_PREFIX}-purchase`,
    SELECT_CONTAINER: `${COMPONENT_PREFIX}-select-container`,
    CHANGE_PLAN: `${COMPONENT_PREFIX}-change`,
    REMOVE_PLAN: `${COMPONENT_PREFIX}-remove`,
    ADD_PLAN: `${COMPONENT_PREFIX}-add`,
    BADGE: `${COMPONENT_PREFIX}-badge`,
    ONELOGO: `${COMPONENT_PREFIX}-logo`,
    DELIVERY_INFO_CONTAINER: `${COMPONENT_PREFIX}-plan-delivery-info-container`,
    DELIVERY_INFO_COUNT: `${COMPONENT_PREFIX}-plan-delivery-info-count`,
    DELIVERY_INFO_SUBTEXT: `${COMPONENT_PREFIX}-plan-delivery-info-subtext`,
};
